import styled from 'styled-components'
import colors from '../../../assets/colors'
import { tokens } from '../../../assets/tokens'

const BoxVideoSentimentsStyled = styled.div`
  
  /* El vídeo y, al lado, el resumen de IA en un panel gris suave */
  .boxInfo {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    align-items: flex-start;
    padding: 24px;
    background: ${tokens.color.background.default};
    /* Misma tarjeta que el bloque de datos personales (#firstSectionStyle) */
    box-shadow: 0 4px 6px rgba(98, 102, 113, 0.06), 0 2px 2px rgba(98, 102, 113, 0.06);
    border-radius: 6px;
  }

  .video-wrapper {
    flex: 1 1 360px;
    min-width: 0;

    video {
      display: block;
      width: 100%;
      max-height: 320px;
      background: ${tokens.color.text.primary};
      border-radius: 12px;
    }
  }

  .summary {
    flex: 1 1 360px;
    min-width: 0;
    padding: 16px 20px;
    background: ${tokens.color.background.light};
    border-radius: 12px;

    .summary-title {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 8px;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      color: ${tokens.color.text.primary};

      svg {
        flex-shrink: 0;
        color: ${props => props.theme.primary || tokens.color.brand.primary};
      }
    }

    .summary-text {
      margin-bottom: 0;
      font-size: 13px;
      font-weight: 400;
      line-height: 1.6;
      color: ${tokens.color.text.secondary};
      white-space: pre-line;
    }
  }

  @media print {
    .header-table {
      background: ${colors.white}!important;
      -webkit-print-color-adjust: exact;

      p {
        color: ${colors.white}!important;
      }
    }
    .wrap-table {
      background-color: ${colors.white}!important;
    }
    && {
      padding: 30px 24px !important;
    }
  }
  && {
    border-radius: 8px;
    padding-top: 24px;

    p {
      position: relative;
      display: block;
    }

    .header-table {
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      padding: 15px 0;

      p {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        color: ${tokens.color.text.primary};
        margin-bottom: 0;
        
        svg {
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
          margin-right: 10px;
        }
        path {
          fill: ${props => props.theme.textPrimary};
        }
      }
    }

    .wrap-table {
      padding: 15px 30px;
      background-color: ${colors.white};
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      position: relative;

      ::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 2px;
        height: 70%;
        background-color: ${colors.greyAlpha25};
      }
    }

    .row-table {
      border-top: 1px solid ${colors.greyAlpha25};
      padding: 10px 0;

      :first-child {
        border-top: 0;
      }

      p {
        margin-bottom: 0;
      }

      .title {
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        color: #181A1C;     
      }

      .value{
        font-weight: 700;
        font-size: 14px;
        line-height: 18px;
        /* identical to box height, or 138% */
        
        text-align: right;        
        color: #494D55;
      }
    }
  }
`

export default BoxVideoSentimentsStyled
